import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-number-input',
  template: `
    <mat-form-field>
      <mat-label>{{ placeholder }}</mat-label>
      <input
        style="border: none;"
        matInput
        type="text"
        [value]="value"
        (keydown)="onKeyDown($event)"
        (input)="onInputChange($event.target.value)"
        [placeholder]="placeholder"
      />
      <mat-error *ngIf="showError">Invalid input. Please enter a valid number.</mat-error>
    </mat-form-field>
  `,
  styles: [
    `
    input {
      width: 100%;
      padding: 0.5rem;
      font-size: 1rem;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
    .error {
      color: red;
      font-size: 0.875rem;
      margin-top: 0.5rem;
    }
    `,
  ],
})
export class NumberInputComponent {
  @Input() placeholder: string = 'Enter a number';
  @Input() value: number | null = null;
  @Output() valueChange: EventEmitter<number | null> = new EventEmitter<number | null>();

  showError: boolean = false;

  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '-', '.',
      ...Array.from({ length: 10 }, (_, i) => i.toString())
    ];
    if (event.key === '-' && (event.target as HTMLInputElement).selectionStart !== 0) {
      event.preventDefault();
      return;
    }
    if (!allowedKeys.includes(event.key) && !(event.ctrlKey || event.metaKey)) {
      event.preventDefault();
    }
  }

  onInputChange(inputValue: string): void {
    if (inputValue.trim() === '') {
      this.value = null;
      this.showError = false;
    } else {
      const parsedValue = parseFloat(inputValue);
      if (!isNaN(parsedValue)) {
        this.value = parsedValue;
        this.showError = false;
      } else {
        this.value = null;
        this.showError = true;
      }
    }
    this.valueChange.emit(this.value);
  }
}
